import { createSlice } from "@reduxjs/toolkit";

const GlobalStatesSlice = createSlice({
  name: "globalStates",
  initialState: {
    Loading: false,
    snackbarMessage: "",
    snackbarOpen: false,
    sellDialogOpen: false,
    restockDialogOpen: false,
    editStoreInfoDialogOpen: false,
    openDeleteDialog: false,
    openItemEditDialog: false,
    openExpiryAlert: false,
    openSettleCredit: false,
    openBarcodeDialog: false,
    openAttendantsDetailsDialog: false,
    openDatePicker: false,
    // collapseQuickStat: false,
    // collapseItems: false,
    // collapseSales: false,
    // collapseInvoiceForm: false,
    // collapseExpenses: false,
    // collapseExpensesForm: false,
    // collapseExpensesHistory: false,
    // collapseAttendantsForm: false,
    // collapseItemsForm: false,
    // collapseCreditStat: false,
    // collapseCreditForm: false,
    // collapseCreditHistory: false,
    openResetDialog: false,
    openReceiptDetailsDialog: false,
  },
  reducers: {
    Load: (state) => {
      state.Loading = !state.Loading;
    },
    toggleBarcodeDialog: (state) => {
      state.openBarcodeDialog = !state.openBarcodeDialog;
    },
    openSnack: (state) => {
      state.snackbarOpen = !state.snackbarOpen;
    },
    snackMessage: (state, action) => {
      state.snackbarMessage = action.payload;
    },
    toggleOpenSellDialog: (state) => {
      state.sellDialogOpen = !state.sellDialogOpen;
    },
    toggleOpenRestockDialog: (state) => {
      state.restockDialogOpen = !state.restockDialogOpen;
    },
    toggleEditStoreInfoDialog: (state) => {
      state.editStoreInfoDialogOpen = !state.editStoreInfoDialogOpen;
    },
    toggleOpenDeleteDialog: (state) => {
      state.openDeleteDialog = !state.openDeleteDialog;
    },
    toggleOpenItemEditDialog: (state) => {
      state.openItemEditDialog = !state.openItemEditDialog;
    },
    toggleExpiryAlert: (state) => {
      state.openExpiryAlert = !state.openExpiryAlert;
    },
    toggleOpenSettleCredit: (state) => {
      state.openSettleCredit = !state.openSettleCredit;
    },
    toggleAttendantsDetailsDialog: (state) => {
      state.openAttendantsDetailsDialog = !state.openAttendantsDetailsDialog;
    },
    toggleDatePicker: (state) => {
      state.openDatePicker = !state.openDatePicker;
    },
    toggleCollapseQuickStat: (state) => {
      state.collapseQuickStat = !state.collapseQuickStat;
    },
    toggleCollapseItems: (state) => {
      state.collapseItems = !state.collapseItems;
    },
    toggleCollapseSales: (state) => {
      state.collapseSales = !state.collapseSales;
    },
    toggleCollapseInvoiceForm: (state) => {
      state.collapseInvoiceForm = !state.collapseInvoiceForm;
    },
    toggleCollapseExpenses: (state) => {
      state.collapseExpenses = !state.collapseExpenses;
    },
    toggleCollapseExpensesForm: (state) => {
      state.collapseExpensesForm = !state.collapseExpensesForm;
    },
    toggleCollapseExpensesHistory: (state) => {
      state.collapseExpensesHistory = !state.collapseExpensesHistory;
    },
    toggleCollapseAttendantsForm: (state) => {
      state.collapseAttendantsForm = !state.collapseAttendantsForm;
    },
    toggleCollapseItemsForm: (state) => {
      state.collapseItemsForm = !state.collapseItemsForm;
    },
    toggleCollapseCreditStat: (state) => {
      state.collapseCreditStat = !state.collapseCreditStat;
    },
    toggleCollapseCreditForm: (state) => {
      state.collapseCreditForm = !state.collapseCreditForm;
    },
    toggleCollapseCreditHistory: (state) => {
      state.collapseCreditHistory = !state.collapseCreditHistory;
    },
    toggleResetDialog: (state) => {
      state.openResetDialog = !state.openResetDialog;
    },
    toggleReceiptDetailsDialog: (state) => {
      state.openReceiptDetailsDialog = !state.openReceiptDetailsDialog;
    },
  },
});

export const {
  Load,
  openSnack,
  snackMessage,
  toggleOpenSellDialog,
  toggleOpenRestockDialog,
  toggleEditStoreInfoDialog,
  toggleOpenDeleteDialog,
  toggleOpenItemEditDialog,
  toggleExpiryAlert,
  toggleOpenSettleCredit,
  toggleBarcodeDialog,
  toggleAttendantsDetailsDialog,
  toggleDatePicker,
  toggleCollapseQuickStat,
  toggleCollapseItems,
  toggleCollapseSales,
  toggleCollapseInvoiceForm,
  toggleCollapseExpenses,
  toggleCollapseExpensesForm,
  toggleCollapseExpensesHistory,
  toggleCollapseAttendantsForm,
  toggleCollapseItemsForm,
  toggleCollapseCreditStat,
  toggleCollapseCreditForm,
  toggleCollapseCreditHistory,
  toggleResetDialog,
  toggleReceiptDetailsDialog,
} = GlobalStatesSlice.actions;

export default GlobalStatesSlice.reducer;
